import React, { useEffect, useState } from 'react';
import SystemDashboard from 'layouts/SystemDashboard';
import { Box, Breadcrumbs } from '@mui/material';
import {
  getInvitation,
  saveInvitation,
  updateInvitation,
} from './InvitationService';
import { useNavigate, useParams } from 'react-router-dom';
import Container from 'components/Container';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';
//import { Checkbox, FormControlLabel } from '@mui/material';

//import MembershipList from '../Memberships/MembershipList';
// import SubscriptionList from '../Subscriptions/SubscriptionList';
//import GroupList from '../Groups/GroupList';

const InvitationDetail = (): JSX.Element => {
  //const { sectionid, itemid } = useParams();
  //   const { sectionid = '' } = useParams<{ sectionid: string }>();
  //   const { itemid = '' } = useParams<{ itemid: string }>();

  const [sender, setSender] = useState('');
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  //const [subscription, setSubscription] = useState('');
  const [status, setStatus] = useState('');

  const navigate = useNavigate();
  const { invitationid } = useParams();

  function clearInvitationDetailsForm() {
    setSender('');
    setEmail('');
    setFirstName('');
    setLastName('');
    //setSubscription('');
    setStatus('');
  }

  const cancelSaveOrUpdateInvitation = () => {
    clearInvitationDetailsForm();
    navigate('/system/dashboard/invitations');
  };

  function saveOrUpdateInvitation(e) {
    e.preventDefault();

    const invitationData = { sender, email, firstName, lastName, status };

    if (invitationid) {
      updateInvitation(invitationid, invitationData)
        .then(() => {
          navigate('/system/dashboard/invitations');
        })
        .catch((error) => {
          console.error(error);
          notify(extractErrorMessage(error));
        });
    } else {
      saveInvitation(invitationData)
        .then(() => {
          navigate('/system/dashboard/invitations');
        })
        .catch((error) => {
          console.error(error);
          notify(extractErrorMessage(error));
        });
    }
  }

  useEffect(() => {
    if (invitationid) {
      console.log('invitationid exists: ', invitationid);
      getInvitation(invitationid)
        .then((response) => {
          console.log(response.data);
          setSender(response.data.sender);
          setEmail(response.data.email);
          setFirstName(response.data.firstName);
          setLastName(response.data.lastName);
          setStatus(response.data.status);
        })
        .catch((error) => {
          console.error(error);
          notify(extractErrorMessage(error));
        });
    }
  }, [invitationid]);

  return (
    <Container>
      <SystemDashboard>
        <Box marginTop={2} marginBottom={4}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              System Content
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href={'/system/dashboard/accounts'}
            >
              Invitations
            </Link>
            <Typography color="text.primary">Invitation Detail</Typography>
          </Breadcrumbs>
        </Box>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          marginBottom={4}
        >
          <Typography variant="h4">Invitation Detail</Typography>
        </Box>
        {/* {loading && <p>Loading...</p>} */}

        <Box>
          <form>
            <Grid container spacing={4}>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Sender
                </Typography>
                <TextField
                  variant="outlined"
                  name={'sender'}
                  fullWidth
                  value={sender} // Use the 'sequence' state variable as the value
                  onChange={(event) => setSender(event.target.value)} // Update the 'sequence' state variable on change
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Email
                </Typography>
                <TextField
                  variant="outlined"
                  name={'email'}
                  fullWidth
                  value={email} // Use the 'name' state variable as the value
                  onChange={(event) => setEmail(event.target.value)} // Update the 'name' state variable on change
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  First Name
                </Typography>
                <TextField
                  variant="outlined"
                  name={'firstName'}
                  fullWidth
                  value={firstName} // Use the 'name' state variable as the value
                  onChange={(event) => setFirstName(event.target.value)} // Update the 'name' state variable on change
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Last Name
                </Typography>
                <TextField
                  variant="outlined"
                  name={'lastName'}
                  fullWidth
                  value={lastName} // Use the 'name' state variable as the value
                  onChange={(event) => setLastName(event.target.value)} // Update the 'name' state variable on change
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Status
                </Typography>
                <TextField
                  variant="outlined"
                  name={'status'}
                  fullWidth
                  value={status}
                  onChange={(event) => setStatus(event.target.value)}
                />
              </Grid>
              <Grid item container xs={12}>
                <Box
                  display="flex"
                  flexDirection={{ xs: 'column', sm: 'row' }}
                  alignItems={{ xs: 'stretched', sm: 'center' }}
                  justifyContent={'space-between'}
                  width={1}
                  //margin={'0 auto'}
                  marginBottom={4}
                >
                  {/* <Box marginBottom={{ xs: 1, sm: 0 }}>
                    <Typography variant={'subtitle2'}>
                      You may also consider to update your{' '}
                      <Link color={'primary'} href={'#'} underline={'none'}>
                        billing information.
                      </Link>
                    </Typography>
                  </Box> */}
                  {/* <Button size={'large'} variant={'contained'} type={'submit'}>
                    Save
                  </Button> */}
                  <Button onClick={cancelSaveOrUpdateInvitation}>Cancel</Button>
                  <Button onClick={saveOrUpdateInvitation}>Save</Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Box>
      </SystemDashboard>
    </Container>
  );
};

export default InvitationDetail;
